module.exports = __webpack_public_path__ + "img/1570128332.a8cd9ecc.jpg";